import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";
import { useDomainConfig } from "../hooks/useDomainConfig";
// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  const domainConfig = useDomainConfig();
  const logoSrc = domainConfig?.logoUrl || "logo/amikCharge.jpg";

  return (
    <Box
      component="img"
      src={logoSrc}
      sx={{ width: 260, height: 'auto', ...sx }}
      alt=""
    />
  );
}

